import { render, staticRenderFns } from "./cATSReport.vue?vue&type=template&id=142b4d68&scoped=true"
import script from "./cATSReport.vue?vue&type=script&lang=js"
export * from "./cATSReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142b4d68",
  null
  
)

export default component.exports